/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalUserSearchOrderBy } from './InternalUserSearchOrderBy';
import {
    InternalUserSearchOrderByFromJSON,
    InternalUserSearchOrderByFromJSONTyped,
    InternalUserSearchOrderByToJSON,
    InternalUserSearchOrderByToJSONTyped,
} from './InternalUserSearchOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface InternalUserSearchOrderByPaginationQuery
 */
export interface InternalUserSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof InternalUserSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof InternalUserSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof InternalUserSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {InternalUserSearchOrderBy}
     * @memberof InternalUserSearchOrderByPaginationQuery
     */
    orderField?: InternalUserSearchOrderBy;
}



/**
 * Check if a given object implements the InternalUserSearchOrderByPaginationQuery interface.
 */
export function instanceOfInternalUserSearchOrderByPaginationQuery(value: object): value is InternalUserSearchOrderByPaginationQuery {
    return true;
}

export function InternalUserSearchOrderByPaginationQueryFromJSON(json: any): InternalUserSearchOrderByPaginationQuery {
    return InternalUserSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function InternalUserSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalUserSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : InternalUserSearchOrderByFromJSON(json['orderField']),
    };
}

export function InternalUserSearchOrderByPaginationQueryToJSON(json: any): InternalUserSearchOrderByPaginationQuery {
    return InternalUserSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function InternalUserSearchOrderByPaginationQueryToJSONTyped(value?: InternalUserSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': InternalUserSearchOrderByToJSON(value['orderField']),
    };
}

